import { useEffect, useState } from 'react';
import * as Sentry from "@sentry/nextjs";

const useLocalStorage = (key, initialValue) => {
  // Define a state variable to store the local value
  const [value, setValue] = useState(initialValue);

  // On the client side, retrieve the value from localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        setValue(JSON.parse(storedValue));
      }
    }
  }, [key]);

  // Update the stored value in localStorage
    const updateValue = (newValue) => {
        try {
            if (newValue.file) {
                newValue.file = {
                    lastModified: newValue.file.lastModified,
                    name: newValue.file.name,
                    size: newValue.file.size,
                    type: newValue.file.type,
                    data: btoa(newValue.file) // Convert the file to base64
                };
            }

            setValue(newValue);
            localStorage.setItem(key, JSON.stringify(newValue));
        } catch (error) {
            console.error(error)
            Sentry.withScope(scope => {
                scope.setTags({'failed-event-submission': 'updateValue in useLocalStorage'})
                Sentry.captureException(error)
            })
        }
    };

  // Clear the stored value from localStorage
  const clearValue = () => {
    setValue(initialValue);
    localStorage.removeItem(key);
  };

  return [value, updateValue, clearValue];
};

export default useLocalStorage;
